"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
exports.isValidationError = isValidationError;
class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.ValidationError = ValidationError;
function isValidationError(error) {
    return error instanceof ValidationError;
}
//# sourceMappingURL=validation.error.js.map